import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
//import ReactDOM from "react-dom/client";
import App from './App.tsx'
import './index.css'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from "@material-tailwind/react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// ReactDOM.createRoot(document.getElementById("root")!).render(
//   // <React.StrictMode> REMOVE THIS IF NECESSARY
//     <App />
//   // </React.StrictMode>
// );
createRoot(document.getElementById('root')!).render(
  <StrictMode>
   <ThemeProvider>
    <BrowserRouter><App /></BrowserRouter>
    </ThemeProvider>
  </StrictMode>,
)

